import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import { Navigation } from '@/components/layout'
import { ProtectedRoute } from '@/components/shared'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ChatButton, ChatPanel } from '@/components/chat'

// Pages
import Dashboard from '@/pages/Dashboard'
import Goals from '@/pages/Goals'
import Achievements from '@/pages/Achievements'
import Retirement from '@/pages/Retirement'
import Portfolio from '@/pages/Portfolio'
import RealEstate from '@/pages/RealEstate'
import Debt from '@/pages/Debt'
import Budget from '@/pages/Budget'
import Education from '@/pages/Education'
import About from '@/pages/About'
import Feedback from '@/pages/Feedback'

// New Life Planner Pages
import Questionnaire from '@/pages/Questionnaire'
import Timeline from '@/pages/Timeline'

function App() {
  // Get API key from environment or localStorage
  const [geminiApiKey] = useState(() => {
    return import.meta.env.VITE_GEMINI_API_KEY || 
           localStorage.getItem('gemini_api_key') || 
           ''
  })
  
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-background">
        <Navigation />
        <main className="container py-6">
          <Routes>
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
            <Route path="/achievements" element={<ProtectedRoute><Achievements /></ProtectedRoute>} />
            <Route path="/retirement" element={<ProtectedRoute><Retirement /></ProtectedRoute>} />
            <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
            <Route path="/real-estate" element={<ProtectedRoute><RealEstate /></ProtectedRoute>} />
            <Route path="/debt" element={<ProtectedRoute><Debt /></ProtectedRoute>} />
            <Route path="/budget" element={<ProtectedRoute><Budget /></ProtectedRoute>} />
            <Route path="/articles" element={<ProtectedRoute><Education /></ProtectedRoute>} />
            <Route path="/about" element={<About />} />
            <Route path="/feedback" element={<Feedback />} />
            
            {/* New Life Planner Routes */}
            <Route path="/questionnaire" element={<ProtectedRoute><Questionnaire /></ProtectedRoute>} />
            <Route path="/timeline" element={<ProtectedRoute><Timeline /></ProtectedRoute>} />
          </Routes>
        </main>
        
        {/* AI Financial Advisor Chat */}
        <ChatButton />
        <ChatPanel apiKey={geminiApiKey} />
        
        <Toaster />
      </div>
    </TooltipProvider>
  )
}

export default App
